import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

interface JobStatsCardProps {
  title: string;
  value: number;
  color: 'info' | 'warning' | 'success' | 'error';
  loading?: boolean;
}

const colorConfig = {
  info: {
    bgcolor: 'info.lighter',
    borderColor: 'info.light',
    color: 'info.dark',
  },
  warning: {
    bgcolor: 'warning.lighter',
    borderColor: 'warning.light',
    color: 'warning.dark',
  },
  success: {
    bgcolor: 'success.lighter',
    borderColor: 'success.light',
    color: 'success.dark',
  },
  error: {
    bgcolor: 'error.lighter',
    borderColor: 'error.light',
    color: 'error.dark',
  },
};

export function JobStatsCard({ title, value, color, loading }: JobStatsCardProps) {
  if (loading) {
    return (
      <Card variant="outlined" sx={{ p: 2, bgcolor: 'grey.50' }}>
        <Skeleton variant="text" width={64} sx={{ mb: 1 }} />
        <Skeleton variant="text" width={48} height={32} />
      </Card>
    );
  }

  const config = colorConfig[color];

  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        bgcolor: config.bgcolor,
        borderColor: config.borderColor,
      }}
    >
      <Typography variant="body2" sx={{ opacity: 0.75, color: config.color }}>
        {title}
      </Typography>
      <Typography variant="h5" fontWeight={700} sx={{ color: config.color }}>
        {value.toLocaleString()}
      </Typography>
    </Card>
  );
}
